<h1 mat-dialog-title>{{title}}</h1>
<div *ngIf="html" [innerHTML]="html"
     mat-dialog-content class="form-inputs">
  html
</div>
<div *ngIf="!html"
     mat-dialog-content class="form-inputs">
  <h4>{{message}}</h4>
</div>
<div mat-dialog-actions class="flex-container">
  <button *ngIf="useGreenButton"
          id = "can-deactivate-dialog-confirm-btn"
          mat-raised-button=""
          class="mat-raised-button btn-green flex-box"
          type="button"
          (click)="cancel()"
  >{{greenButton}}
  </button>
  <button *ngIf="useRedButton"
          id = "can-deactivate-dialog-cancel-btn"
          mat-raised-button=""
          class="mat-raised-button btn-red flex-box"
          type="button"
          (click)="confirm()"
  >{{redButton}}
  </button>
</div>


